// Import Framework7
import Framework7 from 'framework7/lite/bundle';

// Import Framework7-Svelte Plugin
import Framework7Svelte from 'framework7-svelte';

// Import Framework7 Styles
import 'framework7/css/bundle';

import 'framework7-icons';

// Import Custom Styles
import './assets/scss/app.scss';

// Import translations/localization
import './i18n/i18n';
import { waitLocale } from 'svelte-i18n';

// Import App Component
import App from './components/App.svelte';
import {loadAppConfig} from "./helpers/app-config.helper";

// Init F7 Svelte Plugin
Framework7.use(Framework7Svelte)

// Mount Svelte App
async function bootstrap() {
  await loadAppConfig();
  await waitLocale();

  new App({
    target: document.getElementById('app')!
  });
}

bootstrap().catch((error) => {
  console.error('Failed to bootstrap application', error);
});